import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServicePublication {
    lookupService = new APIServiceLookUp();

    async getAllWorkshop(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}workshop/getAllWorkshop`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setWorkshop(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}workshop/setWorkshop`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delWorkshop(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}workshop/delWorkshop`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateWorkshop(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}workshop/updateWorkshop`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}